(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('roverlund-footer-menus')) {
    customElements.define('roverlund-footer-menus', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.menus = Array.from(this.querySelectorAll('[data-footer-menu]')).map((block) => ({
          block,
          button: block.querySelector('[data-footer-toggle]'),
          label: block.querySelector('[data-footer-label]'),
          links: block.querySelector('[data-footer-links]'),
          expanded: false
        })).filter((menu) => menu.button && menu.label && menu.links);

        this.update = () => {
          this.menus.forEach((menu) => {
            const mobile = this.media.matches;
            const open = !mobile || menu.expanded;
            // Keep keyboard focus visible when a resize would hide a focused link.
            if (!open && menu.links.contains(document.activeElement)) menu.expanded = true;
            const visible = !mobile || menu.expanded;
            menu.button.hidden = !mobile;
            menu.label.hidden = mobile;
            menu.links.hidden = !visible;
            menu.button.setAttribute('aria-expanded', String(visible));
            if (!mobile && document.activeElement === menu.button) {
              menu.links.querySelector('a')?.focus({ preventScroll: true });
            }
          });
        };
        this.onClick = (event) => {
          const button = event.target.closest('[data-footer-toggle]');
          const menu = this.menus.find((item) => item.button === button);
          if (!menu || !this.media.matches) return;
          menu.expanded = !menu.expanded;
          this.update();
        };
        this.onSelect = (event) => {
          if (!this.media.matches) return;
          const menu = this.menus.find((item) => item.block === event.target || item.block.contains(event.target));
          if (menu) {
            menu.expanded = true;
            this.update();
          }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onSelect);
        this.media.addEventListener('change', this.update);
        this.update();
        this.setAttribute('data-enhanced', '');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onSelect);
        if (this.media && this.update) this.media.removeEventListener('change', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roverlund-loved-by-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('roverlund-loved-scroll')) {
  customElements.define('roverlund-loved-scroll', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      this.list = this.querySelector('.loved-by__grid');
      if (!this.list || this.dataset.autoScroll !== 'true') return;
      this.viewport = this.querySelector('.loved-by__viewport');
      this.track = this.querySelector('.loved-by__track');
      this.media = matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.refresh = () => {
        this.track.querySelectorAll('.loved-by__clone').forEach(node => node.remove());
        this.removeAttribute('data-scrolling');
        if (!this.media.matches || this.list.children.length < 2) return;
        this.setAttribute('data-scrolling', '');
        const distance = this.list.getBoundingClientRect().width;
        if (!distance) { this.removeAttribute('data-scrolling'); return; }
        this.style.setProperty('--scroll-distance', `${distance}px`);
        this.style.setProperty('--scroll-duration', `${distance / Number(this.dataset.speed || 30)}s`);
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.list.cloneNode(true);
          clone.classList.add('loved-by__clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('aria-labelledby');
          clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
            node.removeAttribute('id'); node.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(clone);
        }
      };
      this.addEventListener('shopify:block:select', () => {
        this.setAttribute('data-paused', '');
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.removeAttribute('data-paused');
      }, options);
      this.media.addEventListener('change', this.refresh);
      this.observer = new ResizeObserver(this.refresh);
      this.observer.observe(this.viewport);
      this.refresh();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
